import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LucideX } from '@lucide/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropDialogBase } from '../../components/image-crop-dialog/image-crop-dialog.base';
import { ImageCropResult, ImageCropperData } from '../../models/images/image-crop.model';
import { ButtonComponent } from '../../styleguide/components/buttons/default/button.component';
import { IconComponent } from '../../styleguide/components/icon/icon.component';

@Component({
  selector: 'ptl-v3-image-crop-dialog',
  templateUrl: './v3-image-crop-dialog.component.html',
  styleUrls: ['./v3-image-crop-dialog.component.scss'],
  standalone: true,
  imports: [TranslocoModule, ImageCropperModule, ButtonComponent, IconComponent],
})
export class V3ImageCropDialogComponent extends ImageCropDialogBase {
  readonly LucideX = LucideX;

  private readonly data = inject<ImageCropperData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<V3ImageCropDialogComponent, ImageCropResult>>(MatDialogRef);
  private readonly cdr = inject(ChangeDetectorRef);

  protected get cropData(): ImageCropperData {
    return this.data;
  }

  protected detectChanges(): void {
    this.cdr.detectChanges();
  }

  protected closeWith(result?: ImageCropResult): void {
    this.dialogRef.close(result);
  }
}
